import routes from './router'
import Router from 'vue-router'
import {post} from './api/index'
import {formatRoutes,loadView} from './utils/index'
const createRouter = () => new Router({
  routes,
})
let isMenus = false;
const router = createRouter();
router.beforeEach(async(to, from, next) => {
  window.scrollTo(0,0)
      next();
  // let token = sessionStorage.getItem('token');
  // if(!isMenus&&token){
  //   isMenus =true;
  //   const { menu,dictionary,user } = await post('admin_base_api/common',{}, false);
  //   sessionStorage.setItem('dictionary', dictionary);
  //   sessionStorage.setItem('user', JSON.stringify(user));
  //   sessionStorage.setItem('menu', JSON.stringify(menu));
  //   var list=formatRoutes(menu)
  //   var obj={
  //     path: '/',
  //     name: '',
  //     component:loadView('Home'),
  //     children: list,
  //   }
  //   router.addRoute(obj);
  //   next({
  //     ...to,
  //     replace:true,
  //   })
  // }else {
  //   let token = sessionStorage.getItem('token');
  //   var white_list = ['/template','/login','/agreement'];
  //   // console.log(white_list.indexOf(to.path))
  //   if (!token && white_list.indexOf(to.path) == -1) {
  //     next({
  //       path: '/login'
  //     })
  //   } else if(to.path == '/'){
  //     next({
  //       path: '/index'
  //     })
  //   }else{
  //     next();
  //   }
  // }
})

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
export default router


// WEBPACK FOOTER //
// ./src/permission.js